import { ChangeEvent, ReactNode, useId } from "react";
import { TextInputProps } from "../props";
import { InputContainer } from "./styles";

interface IInputWithIcon extends TextInputProps {
  icon: ReactNode;
  title: string;
  required?: boolean;
}

export const InputWithIcon = ({
  icon,
  title,
  onChange,
  placeholder,
  value,
  required,
}: IInputWithIcon) => {
  const inputId = useId();

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value);
  }

  return (
    <InputContainer>
      <label htmlFor={inputId}>
        {title} {required && " *"}
      </label>
      <span>
        <div aria-hidden="true">{icon}</div>
        <input
          id={inputId}
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e) => handleChange(e)}
        />
      </span>
    </InputContainer>
  );
};
